<template src="../templates/users.html">

</template>

<script>
    import UsersTableRow from "../components/UsersTableRow";
    import Config from "../config/config";

    export default {
        name: "UsersComponent",
        components: {UsersTableRow},
        data() {
            return {
                isAdmin: false,
                contactModelList: [],
                availableGroups: []
            }
        },

        methods: {
            getContactList() {
                let url = `${this.$localApiURL}contacts/get/all`;
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {
                    self.contactModelList = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            }, getAvailableGroups() {
                let url = `${this.$localApiURL}groups/getAvailableGroups/${Config.projectId}`;
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {
                    self.availableGroups = res.data.filter(x => x.active === "1");
                }).catch(function (error) {
                    console.log(error);
                });
            }

        },
        created() {
            this.isAdmin = localStorage.getItem("isAdmin") === "true";
            this.getContactList();
            this.getAvailableGroups();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UsersComponent.vue